import {getKeyForFilePath} from '../keys';
import {type RunSignature} from './../../../../types/run';

export async function mapCacheResultsByFilepath<T>(
  cache: Map<string, Promise<T>>,
  filePaths: string[],
  runSignature: RunSignature
): Promise<Map<string, T>> {
  const resultsByKey = new Map<string, T>();
  await Promise.all(
    filePaths.map(async filePath => {
      const key = getKeyForFilePath(runSignature, filePath);
      /**
       * This function reads from both internalURL and directURL caches
       *
       * There exists the possibilty of an edge case where a file path has a corresponding directURL but not an internalURL (Note: I don't think this can be true in _theory_, but in practice some kind of internal failure might be able to make this happen).
       *
       * Q: So what happens if you `await` a missing entry on a map?
       * A: nothing, it's fine. You can await non-promise expressions. So this is fine.
       */

      const cachedValue = await cache.get(key);
      // we ignore undefined | null | "" values in the cache
      if (cachedValue) {
        resultsByKey.set(filePath, cachedValue);
      }
    })
  );
  return resultsByKey;
}
